var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from "react";
import { getInvestorSettings, getOrganization, getUser, getUserPreferences, removeAuthTokenFromApi, setAuthTokenToApi, } from "@/services/api";
import { getAuthToken, removeAuthToken } from "@/services/auth";
export function useAuthData() {
    var _this = this;
    var token = getAuthToken();
    var _a = useState(null), user = _a[0], setUser = _a[1];
    var _b = useState(null), organization = _b[0], setOrganization = _b[1];
    var _c = useState(null), investorColors = _c[0], setInvestorColors = _c[1];
    var _d = useState(null), investorSettings = _d[0], setInvestorSettings = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState({
        currency: null,
    }), preferences = _f[0], setPreferences = _f[1];
    var fetchCurrentUser = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var currentUser, preferencesData, currentOrganization, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    setAuthTokenToApi(token);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, getUser()];
                case 2:
                    currentUser = _b.sent();
                    return [4 /*yield*/, getUserPreferences()];
                case 3:
                    preferencesData = _b.sent();
                    setUser(currentUser);
                    setPreferences(preferencesData);
                    if (!currentUser.organizationId) return [3 /*break*/, 5];
                    return [4 /*yield*/, getOrganization()];
                case 4:
                    currentOrganization = _b.sent();
                    setOrganization(currentOrganization);
                    _b.label = 5;
                case 5:
                    setLoading(false);
                    return [3 /*break*/, 7];
                case 6:
                    _a = _b.sent();
                    // eslint-disable-next-line react-hooks/exhaustive-deps
                    token = null;
                    removeAuthToken();
                    removeAuthTokenFromApi();
                    setLoading(false);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [token]);
    var fetchInvestorData = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var investorData, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getInvestorSettings({})];
                case 1:
                    investorData = _b.sent();
                    setInvestorColors(investorData === null || investorData === void 0 ? void 0 : investorData.colors);
                    setInvestorSettings(investorData);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        if (token) {
            fetchCurrentUser();
        }
        fetchInvestorData();
    }, [token, fetchCurrentUser, fetchInvestorData]);
    return {
        token: token,
        user: user,
        preferences: preferences,
        loading: loading,
        organization: organization,
        investorColors: investorColors,
        investorSettings: investorSettings,
    };
}
